// Utility helpers for working with inline images and attachment galleries

import { resolveMediaUrl, toPublicPostAttachmentUrl } from "./mediaUrl";

const IMAGE_URL_EXTENSION_PATTERN = /\.(png|jpe?g|gif|webp|avif)(?:[?#]|$)/i;

export function normalizeMediaUrl(url) {
  try {
    const a = document.createElement('a');
    a.href = url;
    // Compare path + query to be robust to origin changes (gateway vs direct service)
    return (a.pathname || '') + (a.search || '');
  } catch (_) {
    return String(url || '');
  }
}

export function parseImagesFromHtml(html) {
  const items = [];
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${String(html || '')}</div>`, 'text/html');
    const imgs = Array.from(doc.querySelectorAll('img'));
    imgs.forEach((el) => {
      const src = el.getAttribute('src');
      if (!src) return;
      items.push({ src, alt: el.getAttribute('alt') || 'Image' });
    });
  } catch (_) {}
  return items;
}

export function isImageAttachment(attachment) {
  if (!attachment) return false;
  const type = String(attachment.type || attachment.kind || '').toLowerCase();
  const mime = String(attachment.contentType || attachment.mimeType || '').toLowerCase();
  const rawUrl = attachment.url || attachment.previewUrl || attachment.displayUrl || '';
  return (
    type.startsWith('image')
    || mime.startsWith('image/')
    || (Boolean(rawUrl) && IMAGE_URL_EXTENSION_PATTERN.test(rawUrl))
  );
}

export function resolveAttachmentImageUrl(attachment, { publicMedia = false } = {}) {
  if (!isImageAttachment(attachment)) return null;
  const rawUrl = attachment.displayUrl || attachment.previewUrl || attachment.url || null;
  if (!rawUrl) return null;
  const mediaUrl = publicMedia ? toPublicPostAttachmentUrl(rawUrl) : rawUrl;
  return mediaUrl ? resolveMediaUrl(mediaUrl) : null;
}

export function findFirstImageAttachmentUrl(item, options = {}) {
  if (!Array.isArray(item?.attachments)) return null;
  for (const attachment of item.attachments) {
    const imageUrl = resolveAttachmentImageUrl(attachment, options);
    if (imageUrl) return imageUrl;
  }
  return null;
}

export function attachmentsToItems(attachments) {
  const arr = Array.isArray(attachments) ? attachments : [];
  return arr
    .map((a) => {
      const fallbackUrl = a?.displayUrl || a?.url || null;
      const src = resolveAttachmentImageUrl(a) || (fallbackUrl ? resolveMediaUrl(fallbackUrl) : null);
      if (!src) return null;
      return {
        src,
        alt: a.contentType ? `${a.contentType} attachment` : 'Image attachment',
      };
    })
    .filter(Boolean);
}
